export default __webpack_public_path__ + "static/pp_holiday_photo-1-0682b4673883e1254e617b92be4ce4c9.png";